/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightExchangeQuoteSummary } from "./FlightExchangeQuoteSummary";
import {
  FlightExchangeQuoteSummaryFromJSON,
  FlightExchangeQuoteSummaryFromJSONTyped,
  FlightExchangeQuoteSummaryToJSON,
  FlightExchangeQuoteSummaryToJSONTyped,
} from "./FlightExchangeQuoteSummary";
import type { FlightExchangeReplacement } from "./FlightExchangeReplacement";
import {
  FlightExchangeReplacementFromJSON,
  FlightExchangeReplacementFromJSONTyped,
  FlightExchangeReplacementToJSON,
  FlightExchangeReplacementToJSONTyped,
} from "./FlightExchangeReplacement";

/**
 *
 * @export
 * @interface FlightExchangePreparationResponse
 */
export interface FlightExchangePreparationResponse {
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationResponse
   */
  provider: string;
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationResponse
   */
  bookingId: string;
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationResponse
   */
  exchangeId: string | null;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangePreparationResponse
   */
  test: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationResponse
   */
  status: FlightExchangePreparationResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FlightExchangePreparationResponse
   */
  reasonCode: string;
  /**
   *
   * @type {boolean}
   * @memberof FlightExchangePreparationResponse
   */
  canConfirm: boolean;
  /**
   *
   * @type {FlightExchangeReplacement}
   * @memberof FlightExchangePreparationResponse
   */
  replacement?: FlightExchangeReplacement | null;
  /**
   *
   * @type {FlightExchangeQuoteSummary}
   * @memberof FlightExchangePreparationResponse
   */
  quote?: FlightExchangeQuoteSummary | null;
}

/**
 * @export
 */
export const FlightExchangePreparationResponseStatusEnum = {
  Preparing: "preparing",
  Quoted: "quoted",
  NeedsAttention: "needs_attention",
  Expired: "expired",
  Unavailable: "unavailable",
} as const;
export type FlightExchangePreparationResponseStatusEnum =
  (typeof FlightExchangePreparationResponseStatusEnum)[keyof typeof FlightExchangePreparationResponseStatusEnum];

/**
 * Check if a given object implements the FlightExchangePreparationResponse interface.
 */
export function instanceOfFlightExchangePreparationResponse(
  value: object
): value is FlightExchangePreparationResponse {
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  if (!("exchangeId" in value) || value["exchangeId"] === undefined)
    return false;
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("reasonCode" in value) || value["reasonCode"] === undefined)
    return false;
  if (!("canConfirm" in value) || value["canConfirm"] === undefined)
    return false;
  return true;
}

export function FlightExchangePreparationResponseFromJSON(
  json: any
): FlightExchangePreparationResponse {
  return FlightExchangePreparationResponseFromJSONTyped(json, false);
}

export function FlightExchangePreparationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangePreparationResponse {
  if (json == null) {
    return json;
  }
  return {
    provider: json["provider"],
    bookingId: json["booking_id"],
    exchangeId: json["exchange_id"],
    test: json["test"],
    status: json["status"],
    reasonCode: json["reason_code"],
    canConfirm: json["can_confirm"],
    replacement:
      json["replacement"] == null
        ? undefined
        : FlightExchangeReplacementFromJSON(json["replacement"]),
    quote:
      json["quote"] == null
        ? undefined
        : FlightExchangeQuoteSummaryFromJSON(json["quote"]),
  };
}

export function FlightExchangePreparationResponseToJSON(
  json: any
): FlightExchangePreparationResponse {
  return FlightExchangePreparationResponseToJSONTyped(json, false);
}

export function FlightExchangePreparationResponseToJSONTyped(
  value?: FlightExchangePreparationResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    provider: value["provider"],
    booking_id: value["bookingId"],
    exchange_id: value["exchangeId"],
    test: value["test"],
    status: value["status"],
    reason_code: value["reasonCode"],
    can_confirm: value["canConfirm"],
    replacement: FlightExchangeReplacementToJSON(value["replacement"]),
    quote: FlightExchangeQuoteSummaryToJSON(value["quote"]),
  };
}
